import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './AuthContext';
import LoginScreen from './LoginScreen';
import SignUpScreen from './SignUpScreen';
import TechAccessScreen from './TechAccessScreen';
import ParkAccess from './ParkAccess';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { supabase } from './supabaseClient';

function ResetPasswordForm() {
  const { setIsRecovery, signOut } = useAuth();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }
    if (newPassword.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.updateUser({ password: newPassword });
    if (error) {
      setError('Error al actualizar la contraseña. Inténtalo de nuevo.');
      setLoading(false);
    } else {
      setSuccess(true);
      setTimeout(async () => {
        await signOut();
        setIsRecovery(false);
      }, 2000);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f4f2ed'
    }}>
      <div style={{
        background: '#ffffff', border: '1px solid #d4d0c8',
        borderRadius: '12px', padding: '40px', width: '100%', maxWidth: '400px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#1a1c1e' }}>
            Wind<span style={{ color: '#c96a10' }}>Manager</span> Pro
          </div>
          <div style={{ color: '#7a7a72', fontSize: '0.85rem', marginTop: '4px' }}>
            Establecer nueva contraseña
          </div>
        </div>

        {success ? (
          <div style={{ color: '#2e7d32', fontSize: '0.9rem', textAlign: 'center' }}>
            Contraseña actualizada correctamente. Redirigiendo al login...
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', color: '#4a4a44', fontSize: '0.75rem',
                fontWeight: 700, marginBottom: '6px', textTransform: 'uppercase' }}>
                Nueva contraseña
              </label>
              <input
                type="password" value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                required placeholder="••••••••"
                style={{ width: '100%', padding: '10px 12px', background: '#f4f2ed',
                  border: '1px solid #bbb8b0', borderRadius: '6px', color: '#1a1c1e',
                  fontSize: '0.9rem', boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', color: '#4a4a44', fontSize: '0.75rem',
                fontWeight: 700, marginBottom: '6px', textTransform: 'uppercase' }}>
                Confirmar contraseña
              </label>
              <input
                type="password" value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                required placeholder="••••••••"
                style={{ width: '100%', padding: '10px 12px', background: '#f4f2ed',
                  border: '1px solid #bbb8b0', borderRadius: '6px', color: '#1a1c1e',
                  fontSize: '0.9rem', boxSizing: 'border-box' }}
              />
            </div>
            {error && (
              <div style={{ color: '#c0392b', fontSize: '0.85rem',
                marginBottom: '16px', textAlign: 'center' }}>
                {error}
              </div>
            )}
            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '12px', background: '#c96a10',
              border: 'none', borderRadius: '6px', color: '#fff',
              fontSize: '0.95rem', fontWeight: 700, cursor: 'pointer'
            }}>
              {loading ? 'Guardando...' : 'Guardar nueva contraseña'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

function AppWrapper() {
  const { user, loading, isRecovery } = useAuth();

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#f4f2ed',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: '#c96a10', fontSize: '1rem', fontWeight: 700 }}>
      Loading...
    </div>
  );

  if (isRecovery) return <ResetPasswordForm />;
  if (!user) return (
    <Routes>
      <Route path="/" element={<LoginScreen />} />
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/signup" element={<SignUpScreen />} />
      <Route path="/tech-access" element={<TechAccessScreen />} />
    </Routes>
  );
  return <App />;
}

function Root() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/parque/:slug" element={<ParkAccess />} />
        <Route path="/*" element={
          <AuthProvider>
            <AppWrapper />
          </AuthProvider>
        } />
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);
